import { useRoutes } from 'react-router-dom'
import routes from './routes';
import './App.css';
function App() {
  return (
    <div className="App">
      {useRoutes(routes)}
    </div>
  )
}
export default App;
